//
// Crumbs Overflow System
// --------------------------------------------------
// System of functions for handling when the crumbs
// in the Universal Bar overflow the visible space.
// Shows a button when overflowing, which scrolls
// to the right a set amount, and when overflow is
// fully scrolled right, hides the button.
// --------------------------------------------------

import { debounce } from './helpers.js';


const universalBar = document.querySelector("#gctour-universal-bar");
const ubCrumbsWrapper = document.querySelector(".child-tours-crumbs-wrapper");
const ubCrumbsList = document.querySelector(".child-tours-crumbs-list");


export function checkUniversalBarForCrumbsOverflow() {
  ubCrumbsList.classList.toggle(
    'is-overflowing',
    (ubCrumbsList.offsetWidth > ubCrumbsWrapper.offsetWidth)
  );
}
// run immediately
window.requestAnimationFrame(() => checkUniversalBarForCrumbsOverflow() );
// run again after a second, in case any reflows have changed anything
setTimeout(() => {
  window.requestAnimationFrame(() => checkUniversalBarForCrumbsOverflow() );
}, 1000);
// run on window resize (debounced)
window.addEventListener('resize', () => {
  debounce(checkUniversalBarForCrumbsOverflow());
});

export function notifyIfUbCrumbsIsScrolledToTheRight() {
  const scrollRight = Math.floor(ubCrumbsWrapper.scrollWidth - (ubCrumbsWrapper.scrollLeft + ubCrumbsWrapper.clientWidth));

  ubCrumbsList.classList.toggle(
    'is-scrolled-to-right-end',
    (scrollRight < 2)
  );
}

// account for the actual scroll event
export function handleUbCrumbsScrollingAction(event) {
  // console.log('hi there! event: ', event);

  notifyIfUbCrumbsIsScrolledToTheRight();
}

// // unique checker function that needs to wait, due to the effects of scroll-behavior: smooth; CSS being set
// export function handleUbCrumbsScrollingFromButton() {
//   setTimeout(() => {
//     window.requestAnimationFrame(() => {
//       notifyIfUbCrumbsIsScrolledToTheRight();
//     } );
//   }, 200);
// }

// export function hideUbRightCrumbScroller() {
//   document.querySelector('.conditional-overflow-assist-button[data-for-scroll="right"]').hidden = true;
// }

export function handleUbCrumbsScrollButtonClick(event) {
  const btn = event.target.closest('.conditional-overflow-assist-button');
  if (btn) {
    event.preventDefault();
    if (btn.dataset.forScroll === 'right') {
      const currentScrollLeft = ubCrumbsWrapper.scrollLeft;
      // console.log('scrollLeft is starting at ', ubCrumbsWrapper.scrollLeft);

      ubCrumbsWrapper.scrollLeft += 160;

      //
      // handleUbCrumbsScrollingFromButton();
    }
  }
}
window.addEventListener('click', handleUbCrumbsScrollButtonClick);

ubCrumbsWrapper.addEventListener('scroll', (event) => {
  debounce(handleUbCrumbsScrollingAction(event));
});
